export default "__VITE_ASSET__D69Iz85j__"